import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-stock-status-badge',
    templateUrl: './stock-status-badge.component.html',
    styleUrls: ['./stock-status-badge.component.css']
})
export class StockStatusBadgeComponent implements OnInit {

    @Input() status: string;

    constructor() { }

    ngOnInit(): void {
    }

}




